module.exports = __webpack_public_path__ + "img/7304a04.jpg";